const dealerRequests = {
  header: 'Dealers List',
  dealer_requests: 'Dealers Requests',
  search_dealers: 'Search Dealers',
  confirm_modal_confirm: 'Yes, delete',
  no_pending_requests: 'No pending requests',
  approved: 'Approved',
  pending: 'Pending',
  denied: 'Denied',
  in_review: 'In Review',
  approve: 'Approve',
  deny: 'Deny',
  review: 'Review',
  all: 'All',
  submit: 'Submit',
  update: 'Update',
  edit: 'Edit',
  history: 'History',
  email_notifications: 'Email Notifications',
  email_modal_description:
    'This list of email will receive the dealer application',
  email_list_updated: 'Dealer Request Email List Updated',
  dealer_request_updated: 'Dealer Request Updated',
  table: {
    company: 'COMPANY',
    full_name: 'FULL NAME',
    email: 'EMAIL',
    country: 'COUNTRY',
    date: 'DATE',
    status: 'STATUS',
  },
};

export default dealerRequests;
